export const isCustomerGr = (receipt) =>
  Number(receipt?.good_from) === 2 ||
  Boolean(
    receipt?.customer_id &&
      (receipt?.challan_no || receipt?.challan_id),
  );

export const getGoodFromLabel = (receipt) =>
  isCustomerGr(receipt) ? "Customer" : "Supplier";

export const getPartyDisplayName = (receipt) => {
  if (isCustomerGr(receipt)) {
    return receipt?.customer_name || "N/A";
  }
  return receipt?.supplier_name || "N/A";
};

export const getPoOrChallanDisplay = (receipt) => {
  if (isCustomerGr(receipt)) {
    return receipt?.challan_no || "N/A";
  }
  return receipt?.purchase_order_no || "N/A";
};

export const enrichReceiptForExport = (receipt, supplierData = []) => {
  const supplierFromList =
    supplierData.find((s) => s.id === receipt.supplier_id)?.contact_name ||
    supplierData.find((s) => s.id === receipt.supplier_id)?.fname ||
    null;

  const customerMode = isCustomerGr(receipt);

  return {
    ...receipt,
    good_from: customerMode ? 2 : Number(receipt.good_from) || 1,
    supplier_name:
      receipt.supplier_name ||
      receipt.supplier?.contact_name ||
      receipt.supplier?.fname ||
      supplierFromList ||
      "N/A",
    customer_name:
      receipt.customer_name ||
      receipt.customer?.contact_name ||
      receipt.customer?.fname ||
      "N/A",
    challan_no: receipt.challan_no || "",
    challan_id: receipt.challan_id || null,
    customer_id: receipt.customer_id || null,
  };
};

export const normalizeReceiptForPdf = (receipt, supplierData = []) =>
  enrichReceiptForExport(receipt, supplierData);

export const getPdfSourceFields = (receipt) => {
  const goodFrom = getGoodFromLabel(receipt);
  if (isCustomerGr(receipt)) {
    return {
      goodFrom,
      partyLabel: "Customer Name",
      partyValue: receipt.customer_name || "N/A",
      refLabel: "Challan No",
      refValue: receipt.challan_no || "N/A",
    };
  }
  return {
    goodFrom,
    partyLabel: "Supplier Name",
    partyValue: receipt.supplier_name || "N/A",
    refLabel: "Order No",
    refValue: receipt.purchase_order_no || "N/A",
  };
};

export const getPdfSummaryRows = (receipt, extras = {}) => {
  const fields = getPdfSourceFields(receipt);
  const safeBillNo = receipt.purchase_bill_no || receipt.bill_no || "N/A";
  const safeLocation =
    receipt.location_address || receipt.location || receipt.receive_at || "N/A";
  const safeReceivedBy =
    receipt.staff_name ||
    receipt.receive_by ||
    receipt.received_by ||
    receipt.received_name ||
    "N/A";
  const safeBillingDate =
    receipt.billing_date ||
    receipt.receive_date ||
    receipt.receipt_date ||
    receipt.delivery_date;
  const safeBillingDateText = extras.formatDate
    ? extras.formatDate(safeBillingDate)
    : safeBillingDate || "N/A";

  const rows = [
    ["GRN No", receipt.grn_no || "N/A"],
    ["Good From", fields.goodFrom],
    [fields.partyLabel, fields.partyValue],
    [fields.refLabel, fields.refValue],
    ["Bill No", safeBillNo],
    ["Location", safeLocation],
    ["Received By", safeReceivedBy],
    ["Received Date", safeBillingDateText],
    ["Approved Status", receipt.is_approved || "N/A"],
  ];

  return { fields, rows };
};
